import { Actions, Effect, ofType } from '@ngrx/effects';
import { catchError, switchMap } from 'rxjs/operators';
import { SplitUnbilledBalanceService } from 'src/app/services/split-unbilled-balance.service';
import { IEntity } from '@proximus/entity-manager';
import { TechnicalError } from '@dch/products-business-logic';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import * as SplitUnbilledBalanceActions from './../actions/split-unbilled-balence.actions';
import { SplitUnbilledBalance } from 'src/app/details/mobile/level-two/split-bill-detail/split-bill.model';
import { GetSplitUnbilledBalance } from '../actions/split-unbilled-balence.actions';

@Injectable({
  providedIn: 'root',
})
export class SplitUnbilledBalanceEffects {
  @Effect()
  splitUnbilledBalance$: Observable<Action> = this.actions$.pipe(
    ofType(SplitUnbilledBalanceActions.GET_SPLIT_UNBILLED_BALANCE),
    switchMap((action: GetSplitUnbilledBalance) => {
      return this.splitUnbilledBalanceService
        .getSplitUnbilledBalance(action.payload)
        .pipe(
          switchMap((iEntity: IEntity<SplitUnbilledBalance>) => {
            return [
              new SplitUnbilledBalanceActions.GetSplitUnbilledBalanceSuccess(
                iEntity.value,
              ),
            ];
          }),
          catchError((error: IEntity<TechnicalError>) => {
            return of(
              new SplitUnbilledBalanceActions.GetSplitUnbilledBalanceFailed(
                error.errorData as TechnicalError,
              ),
            );
          }),
        );
    }),
  );
  constructor(
    private actions$: Actions,
    private splitUnbilledBalanceService: SplitUnbilledBalanceService,
  ) {}
}
